import { InjectionToken } from '@angular/core';
import { Request, Response } from 'express';

export const RESPONSE = new InjectionToken<Response>('RESPONSE');
export const REQUEST = new InjectionToken<Request>('REQUEST');
